import { PcmVersion, RawPcmVersion } from "@/types/pcmVersion";

export const mapRawToPcmVersion = (raw: RawPcmVersion): PcmVersion => {
  return {
    id: raw.id,
    oTestVersion: raw.pcm_version,
    pcmVersion: raw.pcm_version,
  };
};
